import React from 'react';
import 'assets/scss/home-container.scss';
import { HomeBanner } from 'components/banner/HomeBanner';
import { Button } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import checkIsMobile from 'utils/CheckIsMobile';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { FinancialHelpBanner } from 'components/banner/FinancialHelpBanner';
import { BenefitBanner } from 'components/banner/BenefitBanner';
import { MultiContent } from 'components/multi-content/MultiContent';
import { ShortAnswersContent } from 'components/multi-content/ShortAnswersContent';
import { REQUIREMENTS_BUYER_ANSWERS } from 'constants/answers/Requirements';
import { CardTableAnswersContent } from 'components/multi-content/CardTableAnswersContent';
import { CONVENTIONAL_CREDIT_TYPE, SMART_CREDIT_TYPE } from 'constants/answers/CreditTypes';
import { NavigationBar } from 'components/navs/NavigationBar';

export const HomeContainer = () => {
	const size = checkIsMobile() ? 'medium' : 'large';
	const history = useHistory();
	return (
		<div className="home-container">
			<NavigationBar />
			<HomeBanner />
			<div className="home-container-static-content">
				<div
					style={{
						marginBottom: 32,
					}}
				>
					<h1
						className="title-3 primary-color"
						style={{
							marginBottom: 32,
						}}
					>
						¡Tú eliges cómo pedir tu crédito!
					</h1>
					<ul className="subtitle-1 negro-general" style={{ marginLeft: 20 }}>
						<li>
							<span
								style={{
									fontWeight: 'bold',
								}}
							>
								Autoatención:
							</span>{' '}
							Completa algunos datos, revisa tu simulación, si te interesa el resultado sube tu
							documentación y{' '}
							<span
								className="primary-color"
								style={{
									fontWeight: 'bold',
								}}
							>
								obtén 10% de descuento en la tasa.
							</span>
						</li>
						<li>
							<span
								style={{
									fontWeight: 'bold',
								}}
							>
								Atención normal:
							</span>{' '}
							Completa algunos datos y espera a que un ejecutivo te contacte para gestionar tu
							crédito.
						</li>
					</ul>
				</div>
				<div
					style={{
						marginBottom: 64,
					}}
				>
					<p
						className="title-4 negro-general"
						style={{
							marginBottom: 32,
						}}
					>
						¿Cómo quieres continuar?
					</p>
					<div className="home-buttons-container">
						<Button
							variant="contained"
							color="primary"
							size={size}
							className="home-button"
							endIcon={<ArrowForwardIcon />}
							onClick={() => history.push('/auto-atencion')}
						>
							Autoatención
						</Button>
						<Button
							variant="contained"
							color="secondary"
							size={size}
							className="home-button"
							style={{
								color: '#fff',
							}}
							endIcon={<ArrowForwardIcon />}
							onClick={() => history.push('/credito-automotriz-simple')}
						>
							Atención normal
						</Button>
					</div>
				</div>
				<FinancialHelpBanner />
				<BenefitBanner />
			</div>
			<MultiContent
				title="Tipos de créditos"
				subtitle="¡En Crediautos tenemos las mejores opciones de crédito automotriz para que 
          puedas ahorrar en la compra de tu auto nuevo o usado!"
				optionsTitle={['Convencional', 'Inteligente']}
				selectedContent={[
					<CardTableAnswersContent
						answerItems={CONVENTIONAL_CREDIT_TYPE}
						extraContent={
							<>
								<p
									className="gris-6 body-small"
									style={{
										marginTop: 40,
										textAlign: 'center',
									}}
								>
									*Plazo de 60 meses sólo aplica para autos nuevos con pie mínimo del 30%
								</p>
							</>
						}
					/>,
					<CardTableAnswersContent
						answerItems={SMART_CREDIT_TYPE}
						extraContent={
							<>
								<p
									className="gris-6 body-small"
									style={{
										marginTop: 40,
										textAlign: 'center',
									}}
								>
									*En el caso de autos nuevos el cuotón en 24 meses es del 50% y en 36 meses es del
									40%
								</p>
								<p
									className="gris-6 body-small"
									style={{
										marginTop: 8,
										textAlign: 'center',
									}}
								>
									*En el caso de autos semi nuevos (2 años) el cuotón en 24 meses es del 40% y en 36
									meses es del 30%
								</p>
							</>
						}
					/>,
				]}
				backgroundColor="#F4F4F4"
			/>
			<MultiContent
				title="Requisitos crédito automotriz"
				subtitle="Para obtener tu creditoautomotriz debes cumplir los siguientes requisitos"
				optionsTitle={[]}
				selectedContent={[<ShortAnswersContent answerItems={REQUIREMENTS_BUYER_ANSWERS} />]}
				backgroundColor="white"
			/>
		</div>
	);
};
